import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-without-animation-home-seven',
    templateUrl: './without-animation-home-seven.component.html',
    styleUrls: ['./without-animation-home-seven.component.scss'],
    standalone: false
})
export class WithoutAnimationHomeSevenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
